import React,{useState, useEffect} from 'react';
import * as dbServices from "../../utils/dbServices";
import { Routes, Route, useParams} from 'react-router-dom';

const MtkProfile = () =>{

    const {id} = useParams()    
    const [data,setData] = useState([])

    useEffect(() => {
        getData();
    },[])

    const getData = async () =>{
        const temp = await dbServices.getMtkProfiles()
        console.log(temp)
        setData([...temp])
    }


    const genProfile = (profile) =>{

        const getPageHeader = () =>{
            return(
                <div className='row d-flex' style={{background:"#000000"}}>
                    <img className="ml-2 mr-4 py-4" src="https://cloud-1de12d.becdn.net/media/iW=261&iH=56&oX=0&oY=0&cW=260&cH=56/126163781c08429997f2007c128dc609/1751.png"/>
                    <span className = "ml-4 align-content-end pb-4" style={{color:"#bbbdbf", fontSize:"24px", fontFamily:"Futura"}}>Neighborhood Directory Profile</span>
                </div>
            )
        }

        const genAdultOccupantsCard = (profile) =>{

            const genTable = (profile) =>{

                return(
                    <table className="table w-75">
                        <thead>
                            <th></th>
                            <th>Occupant 1</th>
                            <th>Occupant 2</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>{profile["ho1"]["firstName"] + " " + profile["ho1"]["lastName"]}</td>
                                <td>{profile["ho2"]["firstName"] + " " + profile["ho2"]["lastName"]}</td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td>{profile["ho1"]["email"]}</td>
                                <td>{profile["ho2"]["email"]}</td>
                            </tr>                                                        
                            <tr>
                                <td>Tel (H)</td>
                                <td>{profile["ho1"]["phoneHome"]}</td>
                                <td>{profile["ho2"]["phoneHome"]}</td>
                            </tr>                            
                            <tr>
                                <td>Tel (C)</td>
                                <td>{profile["ho1"]["phoneCell"]}</td>
                                <td>{profile["ho2"]["phoneCell"]}</td>
                            </tr>                            
                            <tr>
                                <td>Tel (W)</td>
                                <td>{profile["ho1"]["phoneWork"]}</td>
                                <td>{profile["ho2"]["phoneWork"]}</td>
                            </tr>                            
 
                        </tbody>
                    </table>
                )
            }

            return (
                <>
                    <div className="card w-75">
                        <div className="card-header" style={{background:"#bbbdbf"}}>
                            <h4 style={{fontFamily:"Futura"}}>Adult Occupants</h4>
                        </div>
                        <div className ="card-body">

                            <br/>
                            {genTable(profile)}
                        </div>
                    </div>
                </>
            )
        }

        const genKidsOcuppantsCard = (kids) =>{

            const genTable = kids =>{

                return(
                    <table className="table w-100">
                        <thead>
                            <th>Name</th>
                            <th>Year Born</th>
                            <th>Email</th>
                            <th>Tel</th>
                            <th>Petcare</th>
                            <th>Babysitting</th>
                            <th>Lawncare</th>
                            <th>Snow Removal</th>
                        </thead>
                        <tbody>
                            {kids.map((x,idx)=>(
                               <tr>
                                    <td>{x["name"]}</td>
                                    <td>{x["yob"]}</td>
                                    <td>{x["email"]}</td>
                                    <td>{x["tel"]}</td>
                                    <td>{x["petcare"]}</td>
                                    <td>{x["babysitting"]}</td>
                                    <td>{x["​​lawncare"]}</td>
                                    <td>{x["​​snowremoval"]}</td>
                               </tr> 
                            ))}
                       </tbody>
                    </table>
                )
            
            }

            return (
                <>
                    <div className="card w-75">
                        <div className="card-header" style={{background:"#bbbdbf"}}>
                            <h4 style={{fontFamily:"Futura"}}>Children</h4>
                        </div>
                        <div className ="card-body">

                            <br/>
                            {genTable(kids)}
                        </div>
                    </div>
                </>
            )



        }

        const genPrivacySettingsCard = (profile) =>{

            return (
                <>
                    <div className="card w-75">
                        <div className="card-header" style={{background:"#bbbdbf"}}>
                            <h4 style={{fontFamily:"Futura"}}>Privacy Settings</h4>
                        </div>
                        <div className ="card-body">
                            <br/>
                            <div className = "row mb-2">
                                <div className="col-2">Publish In Directory</div>
                                <div className="col-6">{profile["directoryPublish"]=="Y"?"Yes":"No"}</div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }

        const genAddInfoCard =(profile) =>{

        }

        const getDetails = (profile) =>{

            if (profile.length==0) return(
                <span>No profile for that mtkId - please pick a valid mtkId </span>
            )

            console.log(profile[0])
            
            return (
                <>  
                    <br/>
                     <div className = "row mb-4 pt-2 pl-4">
                        <h3 style={{fontFamily:"Futura"}}>{profile[0]["addInfo"]["streetAddress"]}</h3>
                    </div>
                    <br/>
                    <div className = "row mb-4 pl-4">
                        {genAdultOccupantsCard(profile[0])}
                    </div>
                    <br/>
                    <div className = "row mb-4 pl-4">
                        {genKidsOcuppantsCard(profile[0]["kidsTable"])}
                    </div>                    
                    <br/>
                    <div className = "row mb-4 pl-4">
                        {genPrivacySettingsCard(profile[0])}
                    </div>
                </>
            )
        }

        return(
            <>
                {getPageHeader()}
                {getDetails(profile)}
            </>
        )
    }

    if (data.length==0) return null

    console.log(id.toString())

    let profile = data.filter(x=>x["mtkId"]===id.toString())

    return(genProfile(profile))


}

export default MtkProfile;